import CountsWidget from './countsWidget'
import StatusWidgetCompact from './statusWidgetCompact'
import { DATA_SOURCE_TYPES } from '../../../../../constants'
import React from 'react'

interface Iprops {
  useMockData?: boolean
  widgetDatasourceId?: string
  widgetDatasourceType?: DATA_SOURCE_TYPES
  widgetDashboardId?: string
}

const OverviewWidget = (props: Iprops) => {
  const { useMockData = false, widgetDatasourceId, widgetDatasourceType, widgetDashboardId } = props
  return (
    <div className="lb-widget-card xs-p-16">
      <CountsWidget
        useMockData={useMockData}
        widgetDatasourceId={widgetDatasourceId}
        widgetDatasourceType={widgetDatasourceType}
        widgetDashboardId={widgetDashboardId}
      />
      <StatusWidgetCompact
        useMockData={useMockData}
        widgetDatasourceId={widgetDatasourceId}
        widgetDatasourceType={widgetDatasourceType}
        widgetDashboardId={widgetDashboardId}
      />
    </div>
  )
}

export default OverviewWidget
